import tmsService from '../../services/tmsService';
import TMS from '../../model/tms';

const state = {
  baseUrl: '/cx-pulse-360',
  tmsList: [],
  pagination: {},
  tms: null,
  uploadedImages: {},
  loading: false,
  downloadList: []
};

const actions = {
  uploadImage({ dispatch, commit }, query = {}, router) {
    dispatch('alert/clear', {}, { root: true });
    const { file, urlName } = query;
    tmsService
      .getSignedUrl({ filename: `${new Date()}-${file.name}`, filetype: file.type, file })
      .then(response => {
        tmsService
          .uploadImage({ url: response.data, file })
          .then(() => { })
          .catch(e => {
            commit('requestFailed');
            dispatch('common/handleServiceException', { e, router }, { root: true });
          });
        commit('setUrl', { image: response.data, urlName });
      })
      .catch(e => {
        commit('requestFailed');
        dispatch('common/handleServiceException', { e, router }, { root: true });
      });
  },
  listTMS({ dispatch, commit }, { query = {}, router }) {
    dispatch('alert/clear', {}, { root: true });

    commit('startRequest');

    tmsService
      .listTMS({ query })
      .then(response => {
        commit('setTMSList', { tmsList: response.data.rows, pagination: response.data.pagination });
      })
      .catch(e => {
        commit('requestFailed');
        dispatch('common/handleServiceException', { e, router }, { root: true });
      });
  },
  getOne({ dispatch, commit }, { id, router }) {
    dispatch('alert/clear', {}, { root: true });
    commit('startRequest');
    commit('clearUploadedImages');

    commit('setTMS', { tms: {} });

    tmsService
      .getOne({ id })
      .then(response => {
        commit('setTMS', { tms: response.data });
      })
      .catch(e => {
        commit('requestFailed');
        dispatch('common/handleServiceException', { e, router }, { root: true });
      });
  },
  postOne({ dispatch, commit }, { tms, router, redirectUrl = '' }) {
    dispatch('alert/clear', {}, { root: true });
    commit('startRequest');

    tmsService
      .postOne({ tms })
      .then(_response => {
        dispatch(
          'alert/success',
          {
            showType: 'toast',
            position: 'center',
            title: '',
            text: 'New CX Pulse 360 has been added.'
          },
          { root: true }
        );

        if (redirectUrl !== '') {
          router.push(redirectUrl);
        }
      })
      .catch(e => {
        commit('requestFailed');
        dispatch('common/handleServiceException', { e, router }, { root: true });
      });
  },
  deleteOne({ dispatch, commit }, { id, router }) {
    dispatch('alert/clear', {}, { root: true });
    commit('startRequest');

    tmsService
      .deleteOne({ id })
      .then(_response => {
        dispatch('listTMS', { id });
        dispatch(
          'alert/success',
          {
            showType: 'toast',
            position: 'center',
            title: '',
            text: ' CX Pulse 360 has been deleted.'
          },
          { root: true }
        );
      })
      .catch(e => {
        commit('requestFailed');
        dispatch('common/handleServiceException', { e, router }, { root: true });
      });
  },
  patchOne({ dispatch, commit }, { id, tms, router, redirectUrl = '' }) {
    dispatch('alert/clear', {}, { root: true });
    commit('startRequest');

    tmsService
      .patchOne({ id, tms })
      .then(_response => {
        dispatch(
          'alert/success',
          {
            showType: 'toast',
            position: 'center',
            title: '',
            text: 'CX Pulse 360 has been updated.'
          },
          { root: true }
        );

        if (redirectUrl !== '') {
          router.push(redirectUrl);
        }
      })
      .catch(e => {
        commit('requestFailed');
        dispatch('common/handleServiceException', { e, router }, { root: true });
      });
  },
  download({ dispatch, commit }, { query = {}, router }) {
    dispatch('alert/clear', {}, { root: true });
    commit('setDownloadTMSList', { downloadList: [] });

    commit('startRequest');
    tmsService
      .listTMS({ query })
      .then(response => {
        dispatch(
          'alert/success',
          {
            showType: 'toast',
            position: 'center',
            title: '',
            text: 'Preparing your download, please wait...'
          },
          { root: true }
        );
        commit('setDownloadTMSList', {
          downloadList: response.data.rows
        });
      })
      .catch(e => {
        commit('requestFailed');
        dispatch('common/handleServiceException', { e, router }, { root: true });
      });
  }
};

const getters = {};

const mutations = {
  setUrl(state, { image, urlName }) {
    const cleanUrl = image.split('?')[0];
    state.uploadedImages = {
      ...state.uploadedImages,
      [urlName]: cleanUrl
    };
  },
  clearUploadedImages(state) {
    state.uploadedImages = {};
  },
  startRequest(state) {
    state.loading = true;
  },
  requestFailed(state) {
    state.loading = false;
  },
  setTMSList(state, { tmsList, pagination }) {
    let row = 0;
    state.tmsList = tmsList.map(tms => {
      const { _id } = tms;
      const newTMS = new TMS({
        id: _id,
        index: row,
        customerName: tms.customerName,
        customerEmail: tms.customerEmail,
        customerMobile: tms.customerMobile,
        ticketOwner: tms.ticketOwner,
        assignedBy: tms.assignedBy,
        platformType: tms.platformType,
        storeId: tms.storeId,
        storeName: tms.storeName,
        region: tms.region,
        state: tms.state,
        city: tms.city,
        share_your_feedback: tms.share_your_feedback,
        openSince: tms.openSince,
        storeManager: tms.storeManager,
        referenceNumber: tms.referenceNumber,
        billDate: tms.billDate,
        billNumber: tms.billNumber,
        assignToStore: tms.assignToStore,
        feedbackType: tms.feedbackType,
        feedbackClass: tms.feedbackClass,
        feedbackSubClass: tms.feedbackSubClass,
        supportingImageUrl: tms.supportingImageUrl,
        attachmentURL: tms.attachmentURL,
        regionForComplain: tms.regionForComplain,
        storeResolution: tms.storeResolution,
        timeOfStoreResolutionByStore: tms.timeOfStoreResolutionByStore,
        action: tms.action,
        ticketNumber: tms.ticketNumber,
        modifiedBy: tms.modifiedBy,
        convoxFormType: tms.convoxFormType,
        department: tms.department,
        team: tms.team,
        updatedAt: tms.updatedAt
      });
      row += 1;
      return newTMS;
    });
    state.pagination = pagination;
    state.loading = false;
  },
  setTMS(state, { tms }) {
    state.tms = new TMS({
      id: tms._id, // eslint-disable-line
      index: tms.index,
      customerName: tms.customerName,
      customerEmail: tms.customerEmail,
      customerMobile: tms.customerMobile,
      ticketOwner: tms.ticketOwner,
      assignedBy: tms.assignedBy,
      platformType: tms.platformType,
      storeId: tms.storeId,
      storeName: tms.storeName,
      region: tms.region,
      state: tms.state,
      city: tms.city,
      rca: tms.rca,
      share_your_feedback: tms.share_your_feedback,
      openSince: tms.openSince,
      correctiveMeasures: tms.correctiveMeasures,
      storeReason: tms.storeReason,
      storeManager: tms.storeManager,
      referenceNumber: tms.referenceNumber,
      billDate: tms.billDate,
      billNumber: tms.billNumber,
      assignToStore: tms.assignToStore,
      feedbackType: tms.feedbackType,
      feedbackClass: tms.feedbackClass,
      feedbackSubClass: tms.feedbackSubClass,
      supportingImageUrl: tms.supportingImageUrl,
      attachmentURL: tms.attachmentURL,
      regionForComplain: tms.regionForComplain,
      storeResolution: tms.storeResolution,
      timeOfStoreResolutionByStore: tms.timeOfStoreResolutionByStore,
      action: tms.action,
      ticketNumber: tms.ticketNumber,
      modifiedBy: tms.modifiedBy,
      convoxFormType: tms.convoxFormType,
      department: tms.department,
      team: tms.team,
      updatedAt: tms.updatedAt
    });
    state.loading = false;
  },
  setDownloadTMSList(state, { downloadList }) {
    state.downloadList = downloadList;
    state.loading = false;
  }
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
